import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 1",
  "description": "",
  "published": "2007-09-19T00:00:00.000Z",
  "redirect_from": ["/blog/london-1/swizec/158"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Welcome to the first post in my London travel blog. I'll try posting at least daily, but might post more than once a day if I deem so fittable. You are welcomed to create lots of traffic on this website and pet my lovely ego in that way. The little bugger will appreciate it greatly.`}</p>
    <p>{`yesterday I left Ljubljana in the midst of the largest rainfall I've ever seen in my life and was later informed that it resulted in flooding, which kind of sucks, but hey, who gives a shit, I'm several thousand kilometers away aren't I? The aeroplane and ports of air were pretty fun to deal with and weren't at all confusing as I'd feared what with being a first time flier and all. There was just quite some waiting to do, which I never like.`}</p>
    <p>{`The flight was very fun, especially in the first part of it when we were climbing through the storm over Ljubljana; the freefalls were something extroadinary ... freefall is bloody awesome.`}</p>
    <p>{`Upon my arrival to London I of course promptly got lost because I took a coach from Stansted that mirraculously (pure luck, didn't know where I was supposed to go) dropped me off quite near my hostel. But I made a newbie mistake and walked the wrong way to it and actually ended up going away from it. So when it finally felt like a bit of a long walk I went to the tube, bought an oyster card and reached the hostel pretty quickly.`}</p>
    <p>{`Then after a bit of finding around the hostel was found, stuff was paid and I went to bed quite soon after. Those backpacks are heavy when combined with walking. Had a calm night and now I'm here, posting this blog for the world to see.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      